import Header from "./header";
import Footer from "./footer";
import MagnificPopup from "./magnific-popup";
import AddToCart from "./add-to-cart";
import CartNumItems from "./cart-num-items";
import Checkout from "./checkout";
import PasswordChange from "./password-change";
import EditOrder from "./edit-order";
import EventOver from "./event-over";


export default {
    Header,
    Footer,
    MagnificPopup,
    AddToCart,
    CartNumItems,
    Checkout,
    PasswordChange,
    EditOrder,
    EventOver
}